import * as H from "history";
import { useLocation } from "react-router-dom";

export interface IPreviousRoutePathResult {
  currentPath: string;
  previousPath?: string;
  currentLocationState: {
    from: H.Location<any>;
  };
}

export function usePreviousRoutePath(): IPreviousRoutePathResult {
  const location = useLocation<any>();
  const from = location?.state?.from;

  return {
    currentPath: `${location.pathname}${location.search}`,
    previousPath: from && `${from.pathname}${from.search}`,
    currentLocationState: {
      from: location,
    },
  };
}
